import { call, put, takeLatest } from "redux-saga/effects";
import { cancilRequestApi, directCareListApi } from "../Api/api";

import {
  careListFail,
  careListLoad,
  careListSuccess,
  deleteCareFail,
  deleteCareLoad,
  deleteCareSuccess,
} from "../slices/directCare.slice";

import { toast } from "react-toastify";
import appconstant from "../../themes/appconstant";

function* CareListSaga(action) {
  try {
    const response = yield call(directCareListApi, action.payload);
    if (response.status === 0) {
      yield put(careListSuccess(response?.result?.data));
    } else if (response.status === 2) {
      toast.success(response?.result);
    } else {
      toast.error(appconstant.serverError);
      yield put(careListFail());
    }
  } catch (e) {
    toast.error(appconstant.serverError);
    yield put(careListFail());
  }
}

// DELETE Care Entry
function* CancelRequestSaga(action) {
  try {
    const response = yield call(cancilRequestApi, action?.payload?.data);
    if (response.status === 0) {
      yield put(deleteCareSuccess());
      toast.success(response?.result?.message);
      action?.payload?.setCancelModal(false);
      yield put(careListLoad(action?.payload?.payload));
    } else if (response.status === 2) {
      toast.success(response?.result);
    } else {
      toast.error(appconstant.serverError);
      yield put(careListFail());
    }
  } catch (e) {
    toast.error(appconstant.serverError);
    yield put(deleteCareFail());
  }
}

export default function* directCareSaga() {
  yield takeLatest(careListLoad.type, CareListSaga);
  yield takeLatest(deleteCareLoad.type, CancelRequestSaga);
}
